import React from 'react';
import proptypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { VIEW_ALL_ORDERS_URL } from './constants';
import { triggerViewAllOrdersAnalytics } from '../../utils/analytics';

const { number, string } = proptypes;

/**
 * The orders tab's "View All Orders (N)" footer, shared by LatestOrdersCard and
 * ActiveOrdersCard so the action, destination and analytics stay the same whichever card
 * the feature switch picks. Callers only render it once real orders have loaded.
 *
 * Matches the Figma "Footer" spec: 24px bottom padding (the space below the button before
 * the card's own edge), 16px right padding on the desktop button only (it's right-aligned
 * via justify-end; the mobile button is fullWidth with no equivalent right inset in spec).
 */
export const ViewAllOrdersFooter = ({ count, testId }) => {
  const label = `View All Orders (${count.toLocaleString()})`;

  // Reuses recent-order-details' existing view-all-orders listener, so no new listener is needed.
  const handleClick = () => triggerViewAllOrdersAnalytics();

  return (
    <div data-testid={testId} className="sui-pb-6">
      <div className="sui-block sm:sui-hidden">
        <Button href={VIEW_ALL_ORDERS_URL} onClick={handleClick} fullWidth>
          {label}
        </Button>
      </div>
      <div className="sui-hidden sm:sui-block">
        <div className="sui-flex sui-justify-end sui-pr-4">
          <Button href={VIEW_ALL_ORDERS_URL} onClick={handleClick} variant="secondary">
            {label}
          </Button>
        </div>
      </div>
    </div>
  );
};

ViewAllOrdersFooter.propTypes = {
  count: number.isRequired,
  testId: string.isRequired,
};
